import * as constants from "../config/actionUrl";
import _ from "underscore";

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties
  };
};

export const convertObjectToArray = (object, propertyName) => {
  return object.map(key => {
    return {
      value: key[propertyName[0]],
      label: key[propertyName[1]]
    };
  });
};

export const getSearchEndPoint = searchParameter => {
  let url = "";

  if (searchParameter === "id") {
    url = constants.PRODUCT_ID_END_POINT;
  } else if (searchParameter === "author") {
    url = constants.CREATED_BY_END_POINT;
  } else if (searchParameter === "date") {
    url = constants.CREATED_DATE_END_POINT;
  } else if (searchParameter === "date range") {
    url = constants.CREATED_DATE_RANGE_END_POINT;
  }
  return url;
};

export const formDataForDownloadFile = fileUrls => {
  let internalFileS3Url = "";
  let externalFileS3Url = "";

  for (let fileUrl of fileUrls.split(",")) {
    if (fileUrl.includes("Viome_External")) {
      externalFileS3Url = fileUrl;
    }
    if (fileUrl.includes("Viome_Internal")) {
      internalFileS3Url = fileUrl;
    }
  }
  let internalFileName = internalFileS3Url
    .split("/")
    .filter(split => split.includes("Viome_Internal"))[0];
  let externalFileName = externalFileS3Url
    .split("/")
    .filter(split => split.includes("Viome_External"))[0];

  return {
    internalFileName: internalFileName,
    internalFileS3Url: internalFileS3Url,
    externalFileName: externalFileName,
    externalFileS3Url: externalFileS3Url
  };
};

export const checkValidity = (value, rules) => {
  let isValid = true;
  if (!rules) {
    return true;
  }

  if (rules.required) {
    isValid = value.trim() !== "" && isValid;
  }

  if (rules.minLength) {
    isValid = value.length >= rules.minLength && isValid;
  }

  if (rules.maxLength) {
    isValid = value.length <= rules.maxLength && isValid;
  }

  if (rules.isEmail) {
    const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    isValid = pattern.test(value) && isValid;
  }

  if (rules.isNumeric) {
    const pattern = /^\d+$/;
    isValid = pattern.test(value) && isValid;
  }

  return isValid;
};

/**
 * Check Object is Empty
 *
 * @param
 */
export const isEmpty = value => {
  return _.isEmpty(value);
};

/**
 * Check Object is not Empty
 *
 * @param
 */
export const isNotEmpty = value => {
  return !_.isEmpty(value);
};
